'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colorManipulator = {};

exports.__exports = colorManipulator;
